





















import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import ServizioDatiServizio from './ServizioDatiServizio.vue';
import { CrudService } from '@/data/services/crud.service';
import { ServiceInstance } from '@/data/models/serviceinstance.model';
import { ServiceInstanceService } from '@/data/services/serviceinstance.service';
import store, { State } from '@/store';

@Component({
	components: {
		ServizioDatiServizio,
	},
})
export default class ServizioDetail extends Vue {
	@Prop() servizioid?: number | string;
	@Prop({ default: true }) editable!: boolean;

	@Inject('CrudService') crudService!: CrudService<ServiceInstance>;
	@Inject('ServiceInstanceService') serviceinstanceService!: ServiceInstanceService;

	serviceinstance!: ServiceInstance;

	loading: boolean = false;
	hqid!: number | undefined;
	state!: State;

	constructor() {
		super();
		this.state = store;
		this.hqid = this.state.headquarter?.id;
		this.serviceinstance = new ServiceInstance();
	}

	loadServizio(id: number) {
		this.loading = true;
		
		this.crudService
			.getEntity(ServiceInstance, 'serviceinstance', id)
			.then(result => {
				this.serviceinstance = result;
			})
			.catch(error => {
				this.$buefy.notification.open({
					message: error.msg,
					type: 'is-danger'
				});
			}).finally(() => this.loading = false);
	}

	created() {
		if (this.servizioid) {
			this.loadServizio(+this.servizioid);
		} else {
			this.serviceinstance = new ServiceInstance();
		}
	}

	submit() {
		this.serviceinstance.hqid = store.headquarter!.id;
		if (this.serviceinstance.patient) this.serviceinstance.patientid = this.serviceinstance.patient.id;
		if (this.serviceinstance.driver) this.serviceinstance.driverid = this.serviceinstance.driver.id;
		if (this.serviceinstance.vehicle) this.serviceinstance.vehicleid = this.serviceinstance.vehicle.id;
		// if (this.serviceinstance.servicetypemodel) this.serviceinstance.servicetype = this.serviceinstance.servicetypemodel.name;
		if (this.serviceinstance.seconddriver) this.serviceinstance.seconddriverid = this.serviceinstance.seconddriver.id;
		if (this.serviceinstance.payer) this.serviceinstance.payerid = this.serviceinstance.payer.id;
		if (this.serviceinstance.startdate) this.serviceinstance.enddate = new Date(this.serviceinstance.startdate.getTime() + 1000);

		const keeproute = !!this.serviceinstance.id;
		this.crudService.createEntity(ServiceInstance, 'serviceinstance', this.serviceinstance).then(result => {
			this.serviceinstance = result;
			if (!keeproute) this.$router.push(`${result.id}/edit`);
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}
}
